var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M25.468 41.497V22.503L42.16 32l-16.692 9.497zM62.6 16.527a8.027 8.027 0 00-5.648-5.684C51.973 9.5 32 9.5 32 9.5s-19.973 0-24.955 1.343A8.033 8.033 0 001.4 16.527C.065 21.54.065 32 .065 32s0 10.46 1.334 15.474a8.033 8.033 0 005.646 5.683C12.027 54.5 32 54.5 32 54.5s19.973 0 24.952-1.343a8.027 8.027 0 005.648-5.683C63.935 42.46 63.935 32 63.935 32s0-10.46-1.335-15.473z","fill":"currentColor","fillRule":"evenodd"}));
}

Youtube.defaultProps = {"viewBox":"0 0 64 64"};

module.exports = Youtube;

Youtube.default = Youtube;
